
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"10.703","height":"12.845"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_32380","data-name":"Path 32380","d":"M13.842 3.229A1.555 1.555 0 0115.2 4.788v11.055l-5.348-2.675L4.5 15.843V4.788a1.554 1.554 0 011.361-1.559 34.612 34.612 0 017.982 0z","transform":"translate(-4.5 -2.998)","fill":"#98a2b7"}})])
          )
        }
      }
    